new Swiper('.featured-collection-slider1', {
    spaceBetween: 24,
    navigation: {
      nextEl: '.arrow-button-next-1',
      prevEl: '.arrow-button-prev-1',
    },
    pagination: {
        el: '.swiper__pagination-1',
        clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2
      },
      991: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
});

new Swiper('.featured-collection-slider2', {
    spaceBetween: 24,
    navigation: {
        nextEl: '.arrow-button-next-2',
        prevEl: '.arrow-button-prev-2',
      },
      pagination: {
          el: '.swiper__pagination-2',
          clickable: true,
      },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2
      },
      991: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
});

new Swiper('.testimonial_wrapper', {
    spaceBetween: 24,
    navigation: {
        nextEl: '.arrow-button-next-3',
        prevEl: '.arrow-button-prev-3',
      },
      pagination: {
          el: '.swiper__pagination-3',
          clickable: true,
      },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2
      },
      991: {
        slidesPerView: 3
      }
    }
});

new Swiper('.video-slider-grid', {
    spaceBetween: 24,
    navigation: {
        nextEl: '.arrow-button-next-4',
        prevEl: '.arrow-button-prev-4',
      },
      pagination: {
          el: '.swiper__pagination-4',
          clickable: true,
      },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2
      },
      991: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
});

new Swiper('.product-image-slider-grid', {
    spaceBetween: 24,
    navigation: {
        nextEl: '.arrow-button-next-5',
        prevEl: '.arrow-button-prev-5',
      },
      pagination: {
          el: '.swiper__pagination-5',
          clickable: true,
      },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2
      },
      991: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
});

new Swiper('[js-recently-viewed-slider]', {
  slidesPerView: 3,
  spaceBetween: 20,
  navigation: {
      nextEl: '.arrow-button-next',
      prevEl: '.arrow-button-prev',
  },
  breakpoints: {
      0: {
        slidesPerView: 2.2,
        spaceBetween: 16
      },
      768: {
          slidesPerView: 2.4,
          spaceBetween: 20
      },
      991: {
          slidesPerView: 3,
          spaceBetween: 20
      }
  }
});

function initProductVariantsSlider() {
  new Swiper('[js-product-variants-slider]', {
    slidesPerView: 'auto',
    freeMode: true
  });
};

initProductVariantsSlider();
document.addEventListener("product-variant-slider:init", initProductVariantsSlider);